/**
 * Application-wide constants.
 * Centralized location for magic values, storage keys, and configuration.
 */

// =============================================
// FEATURE FLAGS
// =============================================

export const FEATURE_FLAGS = {
    /** Enable booking feature (clients can book appointments) */
    BOOKING_ENABLED: false,
} as const;

// =============================================
// API CONFIGURATION
// =============================================

export const API_CONFIG = {
    DEFAULT_PAGE_SIZE: 50,
    SEARCH_LIMIT: 50,
    SEARCH_DEBOUNCE_MS: 300,
} as const;

// =============================================
// TOAST CONFIGURATION
// =============================================

export const TOAST_CONFIG = {
    DEFAULT_DURATION_MS: 3000,
    HAPTIC_DURATION_MS: 10,
} as const;

// =============================================
// QUERY CONFIGURATION
// =============================================

export const QUERY_CONFIG = {
    STALE_TIME_30_SECONDS: 30 * 1000, // 30 seconds
    STALE_TIME_5_MINUTES: 5 * 60 * 1000, // 5 minutes
    STALE_TIME_10_MINUTES: 10 * 60 * 1000, // 10 minutes
    GC_TIME_MS: 5 * 60 * 1000, // 5 minutes
} as const;

// =============================================
// UI CONFIGURATION
// =============================================

export const UI_CONFIG = {
    DROPDOWN_MAX_RESULTS: 10,
    ANIMATION_DURATION_MS: 200,
} as const;
